<template>
  <div
    v-if="isCommentShow"
    class="icon icon_primary icon-message"
    :title="$t('src/components/training/commenticon.3326')"
  ></div>
</template>

<script>
import { status } from '@/main.config.js'

export default {
  name: 'CommentIcon',
  props: {
    training: {
      type: Object,
      required: true
    }
  },
  computed: {
    isCommentShow() {
      return this.training.comment && this.training.status !== status.plan
    }
  }
}
</script>
